import api from "./api";

export default class ContactApi {
  static async post(data) {
    return await api.post(`ask`, data);
  }
}
